export function FlowDrop({ size = 34, dark = false, className = "" }) {
  const drop = dark ? "#1ABC9C" : "#1B4F72";
  const wave = dark ? "#1B4F72" : "#1ABC9C";
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" aria-hidden="true" className={`shrink-0 ${className}`}>
      <path d="M32 3C32 3 13 26 13 40a19 19 0 0 0 38 0C51 26 32 3 32 3Z" fill={drop} />
      <circle cx="24" cy="24" r="2.6" fill={wave} opacity="0.9" />
      <path d="M20 35q4 12 8 3t8 3 8-3" fill="none" stroke={wave} strokeWidth="4.5" strokeLinecap="round" />
    </svg>
  );
}

export default function Logo({ light = false, badge = true }) {
  return (
    <span className="flex items-center gap-2.5">
      <FlowDrop dark={light} />
      <span className="font-display font-extrabold text-xl tracking-tight">
        <span className={light ? "text-white" : "text-[#1B4F72]"}>Wash</span>
        <span className="text-[#1ABC9C]">Flow</span>
      </span>
      {badge && (
        <span className={`hidden sm:inline text-[10px] font-bold uppercase tracking-widest rounded-full px-2 py-0.5 border ${light ? "text-[#AED6F1] border-white/20" : "text-[#5D6D7E] border-[#E2E8F0]"}`}>
          by OpsIQ
        </span>
      )}
    </span>
  );
}
